import EventBus from "./event-bus";

export function showSystemDialog({ title = "", content = "", closeText = "Close" } = {}) {
  EventBus.$emit("system-dialog:open", { title, content, closeText });
}

export function hideSystemDialog() {
  EventBus.$emit("system-dialog:close");
}

export default {
  show: showSystemDialog,
  hide: hideSystemDialog,
};



// WEBPACK FOOTER //
// ./src/api/system-dialog.js